import { useQuery, type UseQueryResult } from '@/lib/query';
import { getCompanyAccessKey } from '@/modules/users/api';
import { CompanyAccessKeyDto } from '@cargovibe/shared-types';

const COMPANY_ACCESS_KEY_QUERY_KEY: string[] = ['company-access-key'];

export const useCompanyAccessKey = (): UseQueryResult<CompanyAccessKeyDto | null> => {
  return useQuery<CompanyAccessKeyDto | null>({
    queryKey: COMPANY_ACCESS_KEY_QUERY_KEY,
    queryFn: getCompanyAccessKey,
  });
};
